import React from "react";
import T from "prop-types";

import { reactComponentType } from "2g-types";

import { useServerMessage, useToLocaleDateString } from "b2b/i18n";
import RezervaceTablePozadavek from "./RezervaceTablePozadavek";

export function RezervaceTableContentTable({
  zdroje,
  dny,
  textComponent: TextComponent
}) {
  const toLocaleDateString = useToLocaleDateString();
  const message = useServerMessage();

  return (
    <table>
      <thead>
        <tr>
          <th></th>
          {zdroje.map(zdroj => (
            <th key={zdroj.id}>
              <TextComponent>{message(zdroj, "nazev")}</TextComponent>
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {dny.map(den => (
          <tr key={den.datum}>
            <td className="b2b-RezervaceTableContent-date">
              <TextComponent>
                {toLocaleDateString(den.datum, {
                  weekday: "long",
                  day: "2-digit",
                  month: "2-digit"
                })}
              </TextComponent>
            </td>
            {zdroje.map((zdroj, index) => (
              <td key={zdroj.id}>
                {den.zdroje[index]?.pozadavky?.map(pozadavek => (
                  <RezervaceTablePozadavek
                    pozadavek={pozadavek}
                    textComponent={TextComponent}
                    key={`${pozadavek.hodinaOd}-${pozadavek.hodinaDo}`}
                  />
                ))}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

RezervaceTableContentTable.propTypes = {
  textComponent: T.oneOfType([reactComponentType, T.oneOf([React.Fragment])]),
  dny: T.array.isRequired,
  zdroje: T.array.isRequired
};

export default React.memo(RezervaceTableContentTable);
